import { Link } from 'react-router';
import { Button } from '../../ui';
import { landingCopy } from './copy';
import { PinMark } from './icons';

/** Props for {@link Hero}. */
export interface HeroProps {
  /** Starts Entra's hosted sign-up flow. */
  readonly onCreateAccount: () => void;
}

/**
 * The landing hero: the brand mark, headline, pitch and the primary calls to action.
 *
 * @param props - Component props.
 * @param props.onCreateAccount - Invoked when the visitor chooses to create an account.
 * @returns The hero section.
 */
export function Hero({ onCreateAccount }: HeroProps): React.JSX.Element {
  return (
    <section className="gm-landing__hero" aria-labelledby="gm-landing-title">
      <div className="gm-landing__hero-inner">
        <span className="gm-landing__pin">
          <PinMark size={56} />
        </span>

        <span className="gm-landing__eyebrow">{landingCopy.eyebrow}</span>

        <h1 id="gm-landing-title" className="gm-landing__title">
          {landingCopy.tagline}
        </h1>

        <p className="gm-landing__pitch">{landingCopy.pitch}</p>

        <div className="gm-landing__cta-row">
          <Button variant="primary" onClick={onCreateAccount}>
            {landingCopy.createAccount}
          </Button>
          <Link className="gm-button gm-button--secondary" to="/events">
            {landingCopy.browseEvents}
          </Link>
        </div>
      </div>
    </section>
  );
}
